module.exports = __webpack_public_path__ + "img/face-crying.d9a0baed.svg";